import {Link} from "react-router-dom";
import React from "react";
import {AlcoCallbackPage} from "./AlcoCallbackPage";

export const AlcoCallbackWrapper = ({userInfo, errorCode, lang, clientCtx}) => {

    return <>
        <AlcoCallbackPage userInfo={userInfo} errorCode={errorCode} lang={lang} clientCtx={clientCtx} />
        <Link to='/'>Back to client selection</Link>
    </>
}
